import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { IFile } from 'src/app/shared/models/file/IFile';
import { map } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import { Store } from '@ngrx/store';
import { getAuthToken } from '../../selectors/user.selectors';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private erService: EnvironmentResolveService) {}

  downloadFile(fileUrl): void {
    window.location.href = fileUrl.replace('/show/', '/get/');
  }

  saveDownloadLink(nodeId: string): Observable<any> {
    return this.http.post(this.erService.environmentERS.apiUrl, {
      application: 'Filemanager',
      method: 'saveDownloadLink',
      parameters: {
        recordData: {
          node_id: nodeId,
          portal: true
        }
      }
    });
  }

  public deleteFile(filenames: string[]): void {
    this.http
      .post(this.erService.environmentERS.apiUrl, {
        application: 'Filemanager',
        method: 'deleteNodes',
        parameters: {
          filenames
        }
      })
      .subscribe();
  }

  public deleteTempFile(fileIds: string[]): void {
    this.http
      .post(this.erService.environmentERS.apiUrl, {
        application: 'Tinebase',
        method: 'deleteTempFiles',
        parameters: {
          fileIds
        }
      })
      .subscribe();
  }

  public uploadFiles(files: IFile[]): Observable<{ file: IFile; result: any }>[] {
    const status: Observable<{ file: IFile; result: any }>[] = [];
    this.store.select(getAuthToken).subscribe((authToken: string) => {
      files.forEach(file => {
        const formData: FormData = new FormData();
        formData.append('file', file.file);
        formData.append('unique', '1');
        formData.append('overwrite', '0');

        const req = new HttpRequest('POST', this.erService.environmentERS.uploadUrl, formData, {
          headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` })
        });
        const progress = new Subject<any>();

        this.http.request(req).subscribe(
          event => {
            if (event instanceof HttpResponse) {
              progress.next(event);
            }
          },
    error => {
            progress.error({
              error: error.error,
              message: error.message,
              file
            });
          }
        );
        status.push(progress.asObservable().pipe(map(result => ({ result, file }))));
      });
    });
    return status;
  }
}
